/**
 * AllClubMembersTab — extracted from SchoolClubsPage during Iter28 refactor.
 *
 * Renders the cross-club members table (one row per member, with badge of the
 * member's club). Pure presentational — receives the full club + member list.
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../ui/table';

const AllClubMembersTab = ({ clubs = [], members = [], clubColors = {} }) => (
  <Card>
    <CardHeader>
      <CardTitle>All Club Members</CardTitle>
      <CardDescription>Across all school clubs</CardDescription>
    </CardHeader>
    <CardContent>
      {members.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground" data-testid="all-members-empty">No members yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Student</TableHead>
                <TableHead>Club</TableHead>
                <TableHead>Role</TableHead>
                <TableHead>Parent</TableHead>
                <TableHead>Parent Contact</TableHead>
                <TableHead>Parent Email</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="all-members-table-body">
              {members.map((m) => {
                const club = clubs.find((c) => c.id === m.club_id);
                return (
                  <TableRow key={m.id}>
                    <TableCell className="font-medium">{m.student_name}</TableCell>
                    <TableCell>
                      {club ? (
                        <Badge className={clubColors[club.club_type]}>{club.name}</Badge>
                      ) : '—'}
                    </TableCell>
                    <TableCell>{m.role}</TableCell>
                    <TableCell>{m.parent_name || '—'}</TableCell>
                    <TableCell>{m.parent_contact || '—'}</TableCell>
                    <TableCell>{m.parent_email || '—'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </CardContent>
  </Card>
);

export default AllClubMembersTab;
